import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFormPentagon: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconFormPentagon"><Path d="M10.2366 3.03115C11.2881 2.26722 12.7119 2.26722 13.7634 3.03115L19.985 7.55142C21.0364 8.31535 21.4764 9.66946 21.0748 10.9055L18.6983 18.2195C18.2967 19.4555 17.1449 20.2924 15.8452 20.2924H8.15483C6.85515 20.2924 5.70328 19.4555 5.30166 18.2195L2.92521 10.9055C2.52359 9.66946 2.96356 8.31535 4.01503 7.55142L10.2366 3.03115Z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconFormPentagon;
